// Sugalarm — Cycle 84: the theme background-image layer.
//
// A non-interactive layer painted BEHIND all content (z-index: -1, so
// it sits above the surface's own `--display-bg` ground but below every
// screen element). Mounted on the kiosk frame and the web app frame
// only — never on mobile (the phone shows Light/Dark, no background
// image). When no background is selected it renders nothing and the
// theme's gradient ground shows through.
//
// The image bytes are served behind auth, so we can't point CSS `url()`
// straight at the endpoint (no Authorization header on a CSS fetch) —
// `fetchImageObjectUrl` pulls the blob with the bearer and hands back an
// object URL, revoked on change / unmount. A legibility scrim derived
// from the active theme's `--bg` keeps the hero + chrome readable over a
// bright photo across all themes.

import { useEffect, useState } from "react";

import * as backgroundsApi from "../api/backgrounds";
import { useSettings } from "../hooks/useSettings";
import styles from "./ThemeBackground.module.css";

export function ThemeBackground() {
  const { settings } = useSettings();
  const bgId = settings?.display_background_id ?? null;
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!bgId) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    let objUrl: string | null = null;
    void backgroundsApi.fetchImageObjectUrl(bgId).then((u) => {
      if (cancelled) {
        if (u) URL.revokeObjectURL(u);
        return;
      }
      objUrl = u;
      setUrl(u);
    });
    return () => {
      cancelled = true;
      if (objUrl) URL.revokeObjectURL(objUrl);
      setUrl(null);
    };
  }, [bgId]);

  if (!bgId || !url) return null;

  return (
    <div className={styles.layer} aria-hidden="true">
      <div
        className={styles.image}
        style={{ backgroundImage: `url(${url})` }}
      />
      <div className={styles.scrim} />
    </div>
  );
}
